import { yellow } from '@mui/material/colors';

const STACKED_ALERT_TOP_PADDING = 6;

export const getAlertToneStyles = theme => ({
  warning: {
    color: yellow[500],
    '&:nth-child(n + 2)': {
      paddingTop: STACKED_ALERT_TOP_PADDING,
    },
  },
  severe: {
    color: theme.palette.error.A700,
    '&:nth-child(n + 2)': {
      paddingTop: STACKED_ALERT_TOP_PADDING,
    },
  },
});
